interface ReportChild {
    id: string;
    intake_status?: string;
}

interface ReportCheck {
    layer_id: string;
}

export const filterChecksByReportView = <T extends ReportCheck>(
    checks: T[],
    children: ReportChild[],
    viewType: string
): T[] => {
    if (!viewType || viewType === "full") return checks;
    if (viewType === "summary") return [];

    const includedStatuses = new Set(viewType.split(","));
    const childStatuses = new Map(children.map((child) => [child.id, child.intake_status]));

    return checks.filter((check) => includedStatuses.has(childStatuses.get(check.layer_id) || ""));
};

interface ReportRenderUnit {
    layer?: { id?: string };
}

// Pages for the report layer itself (e.g. the order overview) stay in every view;
// only pallet pages are filtered, matching the general intake template.
export const filterRenderUnitsByReportView = <T extends ReportRenderUnit>(
    units: T[],
    children: ReportChild[],
    viewType: string,
    reportLayerId: string
): T[] => {
    if (!viewType || viewType === "full") return units;

    const isReportLayerUnit = (unit: T) => !unit.layer?.id || unit.layer.id === reportLayerId;
    const childUnits = units
        .filter((unit) => !isReportLayerUnit(unit))
        .map((unit) => ({ unit, layer_id: unit.layer?.id as string }));
    const includedUnits = new Set(filterChecksByReportView(childUnits, children, viewType).map(({ unit }) => unit));

    return units.filter((unit) => isReportLayerUnit(unit) || includedUnits.has(unit));
};
